// extracted by mini-css-extract-plugin
export default {"departments":"UI-z","departmentHeading":"VI-z","departmentSection":"WI-z","departmentName":"XI-z","departmentLink":"YI-z","expandIcon":"ZI-z"};